import { render, staticRenderFns } from "./FoodPriceManagement.vue?vue&type=template&id=12f74998&scoped=true&"
import script from "./FoodPriceManagement.vue?vue&type=script&lang=ts&"
export * from "./FoodPriceManagement.vue?vue&type=script&lang=ts&"
import style0 from "./FoodPriceManagement.vue?vue&type=style&index=0&id=12f74998&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f74998",
  null
  
)

export default component.exports